{
  "questionnaire": {
    "welcomeIntro": "Hilf uns, dich einzurichten, indem du ein paar kurze Fragen beantwortest",
    "step": "Schritt",
    "steps": "Schritt {{ currentStep }} von {{ totalSteps }}",
    "reason": {
      "question": "Erzählen Sie uns, was Sie heute zu Iventis gebracht hat?",
      "options": {
        "SitePlanForMyEvent": "Um einen Lageplan für meine Veranstaltung zu erstellen",
        "TeamPlanMoreEfficiently": "Erfahren Sie, wie mein Team effizienter planen kann",
        "PlanMultipleEventsPerProject": "Erfahren Sie, wie Sie mehrere Veranstaltungen oder Projekte planen",
        "JustCurious": "Ich bin nur neugierig"
      }
    },
    "eventType": {
      "question": "Und was willst du planen?",
      "options": {
        "SportsEvent": "Sportveranstaltung",
        "RoadEvent": "Veranstaltung im Straßenverkehr",
        "FestivalOrParade": "Festival oder Parade",
        "ExhibitionOrShow": "Ausstellungen und Konferenzen",
        "MajorEvent": "Wichtiges Ereignis",
        "MultipleEvents": "Mehrere Ereignisse",
        "Venue": "Ein Veranstaltungsort",
        "SomethingElse": "Etwas anderes"
      }
    },
    "experience": {
      "question": "Wie viel Erfahrung haben Sie mit Planungstools?",
      "options": {
        "HaventUsedBefore": "Ich habe noch nie welche benutzt",
        "Powerpoint": "Habe PowerPoint benutzt",
        "GoogleEarth": "Verwendete Apps wie Google Earth",
        "GisAndCadSoftware": "Verwendete GIS- und CAD-Software",
        "Iventis": "Ich habe Iventis schon einmal benutzt"
      }
    },
    "projectName": {
      "question": "Und zum Schluss, welchen Namen haben Sie heute für Ihr Projekt im Sinn?",
      "subLabel": "Hinweis: Das könnte dein Event oder dein Firmenname sein.",
      "options": {
        "projectName": "Name des Projekts"
      },
      "label": "Bitte geben Sie einen Namen für Ihr Projekt ein:"
    },
    "skip": "Überspringen Sie vorerst",
    "ending_screen": {
      "initial_loading": {
        "message": "Wir richten gerade die Dinge für Sie ein",
        "subtext": "Wir richten Ihr Projekt ein und analysieren Ihre Anforderungen",
        "footerText": "Dies kann einige Sekunden dauern"
      },
      "taking_longer": {
        "message": "Es dauert etwas länger als erwartet, warte!",
        "subtext": "Wir schärfen unsere Werkzeuge, um Ihnen die schärfsten Ergebnisse zu liefern",
        "footerText": "Das kann ein paar Sekunden dauern"
      },
      "error": {
        "message": "Ups, da ist etwas schief gelaufen.",
        "subtext": "Es scheint ein Problem auf unserer Seite zu geben.",
        "footer_1": "Bitte",
        "footer_2": "damit wir dir helfen können herauszufinden, was passiert ist."
      }
    },
    "setup_completed": "Einrichtung abgeschlossen"
  },
  "passwordConditions": {
    "commonPassword": "Das Passwort ist zu einfach. Bitte versuchen Sie es mit etwas komplexerem."
  },
  "verification": {
    "headings": {
      "checkEmail": "Überprüfe deine E-Mail",
      "emailVerified": "E-Mail bestätigt",
      "alreadyVerified": "Du bist startklar"
    },
    "ctas": {
      "continueToLogin": "Weiter zum Einloggen",
      "resendEmail": "Zum erneuten Senden hier klicken"
    },
    "noEmail": "Haben Sie die E-Mail nicht erhalten?",
    "emailSent": "Wir haben einen Bestätigungslink gesendet an",
    "timerForResend": "in {{ time }} Sekunden",
    "accountVerifiedMessage": "Ihr E-Mail-Konto wurde verifiziert. Klicken Sie auf die Schaltfläche unten, um sich anzumelden.",
    "unverifiedErrorMessage": "Wir konnten Ihr E-Mail-Konto nicht verifizieren. Bitte kontaktieren Sie unser Support-Team unter",
    "alreadyVerifiedMessage": "Dieses E-Mail-Konto wurde bereits verifiziert. Klicken Sie auf die Schaltfläche unten, um sich anzumelden."
  },
  "createAccount": {
    "free_trial": "Kostenlose Testversion starten",
    "marketing": "Halten Sie mich über die neuesten Nachrichten und Updates auf dem Laufenden",
    "iventisAccount": "Haben Sie bereits ein Iventis-Konto?",
    "error": "Bei der Erstellung Ihres Kontos ist ein Problem aufgetreten. Bitte wenden Sie sich an",
    "disableAdBlocker": "oder versuchen Sie, Ihren Werbeblocker zu deaktivieren und versuchen Sie es erneut."
  },
  "logout": "Loggen Sie sich aus"
}